import { React } from 'react'

import classNames from 'classnames'
import styles from './style.module.scss'

function CardView(props) {
  const { header, children, className } = props

  return (
    <div className={classNames(styles.CardView, 'CardView', className)}>
      <div className={classNames(styles.CardBorder)}>
        <div className={classNames(styles.cardHeader)}>{header}</div>
        {children}
      </div>
    </div>
  )
}

export default CardView
